<div class="planning-details-container">
    <div fxLayout="column" fxLayoutAlign="start center">
        <div fxFlex="nogrow" fxLayout="column" fxLayoutGap="6px">
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Source'|i18n}}</div>
                <div>{{(planning|planningSource) || 'Unknown'|i18n}}</div>
            </div>
            <div *ngIf="planner as planner" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Planner'|i18n}}</div>
                <div>{{plannerName(planner)|i18n}}</div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Created'|i18n}}</div>
                <div>{{planning.planning_timestamp|i18nTimestamp}}</div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Time range'|i18n}}</div>
                <div>{{planning.start_time|i18nTimestamp}} ÷ {{planning.end_time|i18nTimestamp}}</div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Strategy'|i18n}}</div>
                <div>{{(planning|planningStrategy) || ('Unknown'|i18n)}}</div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Outcome'|i18n}}</div>
                <div>
                    <app-icon [name]="planning.status|planningStatusIcon"></app-icon>&nbsp;
                    {{planning.status|planningStatus}}
                </div>
            </div>
            <div *ngIf="cost !== null" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Cost'|i18n}}</div>
                <div>{{cost|niceValue:'€':2}}</div>
            </div>
            <div *ngIf="sharedEnergy !== null" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Shared energy'|i18n}}</div>
                <div>{{sharedEnergy|niceValue:'kWh'}}</div>
            </div>
        </div>
    </div>
</div>
